import {
  ApiResponseError,
  ApiSessionTimeoutError,
  classifyApiError,
  unwrapResponseModel
} from '../api/responseModel';

export {
  ApiResponseError as CarrerasApiError,
  ApiSessionTimeoutError as CarrerasSessionTimeoutError,
  classifyApiError as classifyCarrerasError,
  unwrapResponseModel
};

export function toCreateCarreraPayload({ name, anioImplementacion, resolucionMinisterial }) {
  return {
    CarreraNombre: name,
    CarreraAnioImplementacion: anioImplementacion,
    CarreraResolucionAprobacion: resolucionMinisterial,
    CarreraExtinta: 'N'
  };
}

export function toUpdateCarreraPayload({ id, name, anioImplementacion, resolucionMinisterial, extinta }) {
  return {
    CarreraNombre: name,
    CarreraAnioImplementacion: anioImplementacion,
    CarreraResolucionAprobacion: resolucionMinisterial,
    CarreraExtinta: extinta,
    CarreraCod: parseInt(id, 10)
  };
}

export function validateCarreraForm({ name, anioImplementacion, resolucionMinisterial, extinta }) {
  const hasExtinta = extinta === undefined || extinta === null || String(extinta).length > 0;
  return Boolean(
    name?.length > 0
    && anioImplementacion?.length > 0
    && resolucionMinisterial?.length > 0
    && hasExtinta
  );
}

export function mapCarrerasToSelectOptions(carreras) {
  return [...carreras]
    .filter((item) => String(item?.carreraExtinta || 'N').trim().toUpperCase() !== 'S')
    .sort((a, b) => (a.carreraCod ?? 0) - (b.carreraCod ?? 0))
    .map((item) => ({
      value: String(item.carreraCod),
      label: String(item.carreraNombre || '').trim(),
    }));
}
